import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';

export abstract class AsyncService {
    abstract process(action: Action): Observable<any>;
}
